"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconEuro = function IconEuro(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m.502 2.91c1.2 0 2.19.345 3.06.99l-.885 1.545c-.66-.51-1.23-.78-2.146-.78-1.065 0-1.934.54-2.385 1.59h4.066l-.75 1.305h-3.6c-.016.135-.015.27-.015.405s0 .27.014.405h3.15l-.75 1.305h-2.114c.45 1.05 1.32 1.59 2.384 1.59.915 0 1.486-.27 2.146-.78l.885 1.545c-.87.645-1.86.99-3.06.99-2.07 0-3.81-1.215-4.41-3.345H6.937V12.37h.945l-.016-.405c0-.135 0-.27.016-.405h-.945v-1.305h1.155c.6-2.13 2.34-3.345 4.41-3.345"
  })));
};

export { IconEuro, IconEuro as default };
